import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { TranslateService } from '@ngx-translate/core';
import { MsalService } from '@azure/msal-angular';
import { GraphService } from 'src/app/services/graph.service';
import { UserService } from 'src/app/services/user.service';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
import { DcnErrorComponent } from '../../dcn-error/dcn-error.component';
import { Roles } from '../../model/roles';
import { SortableColumn } from '../../model/sort/sortable-column';
import { StoreMaintainenceResponse } from '../../model/store-maintainence-response';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';
import { merge, Observable, of as observableOf, ReplaySubject, Subject } from 'rxjs';
import { catchError, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MatOption } from '@angular/material/core';
import { ShowOnDirtyOrTouchedErrorStateMatcher } from '../../shared/show-on-dirty-or-touched-error-state-matcher';


@Component({
    selector: 'app-add-edit-store-user',
    templateUrl: './add-edit-store-user.component.html',
    styleUrls: ['./add-edit-store-user.component.scss'],
    standalone: false
})
export class AddEditStoreUserComponent implements OnInit {
  userAction: string = null;
  isDisabled: boolean = false;
  isHidden: boolean = false;
  user: UsersDataResponse;
  userData: UserData;
  storeUserForm: UntypedFormGroup;
  sortableColumn: SortableColumn;
  statusString: string;
  currentUserStores = [];
  storeNumbers: StoreMaintainenceResponse[] = [];
  addUserButton: boolean;
  selectedStoreNumber: string;
  userRoles: Roles[] = [];
  dateTimeFormat: string = 'yyyy-MM-dd hh:mm:ss a';
  filteredStoreOptions: Observable<StoreMaintainenceResponse[]>;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  selectedStores: string[] = [];
  stores:StoreMaintainenceResponse[]=[]
  selectedAll: boolean = false;
  upnChanged: boolean = false;
  nameErrorMatcher = new ShowOnDirtyOrTouchedErrorStateMatcher();
  searchTextboxControl = new UntypedFormControl();
  @ViewChild('search') searchTextBox: ElementRef;
  /** list of banks filtered by search keyword for multi-selection */
  public filteredStoresMulti: ReplaySubject<StoreMaintainenceResponse[]> = new ReplaySubject<StoreMaintainenceResponse[]>(1);
  private _onDestroy = new Subject<void>();
  constructor(private router: Router, private userservice: UserService, private fb: UntypedFormBuilder, private route: ActivatedRoute,
    private authService: MsalService, private graphService: GraphService, private dialog: MatDialog,
    public translate: TranslateService) {
    this.createForm();

    this.statusString = 'Active'; //init val
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');

    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      this.translate.use(this.userData.language.toLowerCase());
      let lang = this.userData.language.toLowerCase();
      if (lang === 'fr') {
        this.dateTimeFormat = "medium";
      }

    })
  }

  filteredOptions: Observable<any[]>;

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.userAction = params['action'];
        this.selectedStoreNumber = params['store-number'];
        if (this.userAction === 'profile' || this.userAction === 'store-user-edit') {
          if (this.userAction === 'profile') {
            this.storeUserForm.controls.language.enable();
            this.storeUserForm.controls.license.enable();
            this.storeUserForm.controls.storeNumber.enable();
            this.storeUserForm.controls.firstName.enable();
            this.storeUserForm.controls.lastName.enable();
          }
          this.isDisabled = true;
          this.isHidden = true;
          this.route.params.subscribe(
            (params) => {
              let upn = params.upn;
              this.getUserDeailsBySeq(upn);
            })
        } else {
          this.user.stores.forEach(element => {
            element.selected = false;
            if (element.roleId === 4) {
              this.storeNumbers.push(element);
              this.stores.push(element);
              this.filteredOptions = this.searchTextboxControl.valueChanges
              .pipe(
                startWith<string>(''),
                map(name => this._filter(name))
              );
             }
            });
          this.roleAccessData();
        }
      }
    );
  }

  roleAccessData() {
    this.userRoles = [];
    this.user.lstAccess.forEach(e => {
      if (e.roleIdAccess > 3) {
        this.userRoles.push(e)
      }
    })
  }

  saveUser() {
    this.trimNameFields();
    if (this.userAction === 'store-user-edit') {
      let upnModified=this.userservice.getObject("upn_value")!==this.storeUserForm.controls.upn.value;
      if (this.userData.roleId === 1 && upnModified) {
        this.validateUser(this.storeUserForm.controls.upn.value);
      } else {
        this.saveUserData();
      }

    } else
      if (this.userAction === 'store-user-add') {
       
          this.validateUser(this.storeUserForm.controls.upn.value);
       }
      else {
        this.saveProfile();
      }

  }

  userView: UsersDataResponse;
  userDataView: UserData;
  getUserDeailsBySeq(seq) {
    this.userRoles = [];
    this.storeNumbers = [];
    this.userservice.getUserDataBySeq(seq).subscribe(data => {
      this.userView = data;
      this.userDataView = data.userData
      this.userservice.setObject("upn_value",this.userDataView.upn)
      if (this.userAction === 'store-user-edit') {
        if (this.user.userData.roleId > 1) {
          this.storeUserForm.controls.upn.disable();
        }
        this.storeUserForm.controls.storeNumber.disable();
        this.storeNumbers = this.user.stores.filter(s => s.storeNumber === this.selectedStoreNumber && s.roleId === 4
        );
      } else
        if (this.userAction === 'store-user-add') {
          this.storeNumbers = this.user.stores.filter(s => s && s.roleId === 4);

        }
      if (this.userAction === 'profile') {
        this.storeNumbers = this.user.stores.filter(s => s);
        this.storeUserForm.disable();
        this.storeUserForm.controls.license.enable();
        this.storeUserForm.controls.language.enable();
        this.storeUserForm.controls.storeNumber.enable();
        this.storeUserForm.controls.firstName.enable();
        this.storeUserForm.controls.lastName.enable();
        this.storeNumbers.forEach(s => {
          let roles = new Roles();
          roles.roleIdAccess = s.roleId;
          roles.roleName = s.roleName;
          this.userRoles.push(roles)
        })
      } else {
        this.roleAccessData();
      }
      //this.dropdownSettings=this.defaultSettings;  
      this.userView.stores.forEach(element => {
        if (element.storeNumber === this.selectedStoreNumber) {
          this.selectedItems.push({ id: element.storeNumber, text: element.banner + "-" + element.sdmStoreNumber });
        }
      });

      this.storeUserForm.patchValue({
        firstName: this.trimmed(this.userDataView.firstName),
        lastName: this.trimmed(this.userDataView.lastName),
        intials: this.trimmed(this.userDataView.intials),
        license: this.userAction === 'profile' ? this.storeNumbers[0].license : (this.userView.stores.filter(s => s.storeNumber === this.selectedStoreNumber))[0].license,
        upn: this.userDataView.upn,
        province: this.userDataView.province,
        sequenceNumber: this.userDataView.sequenceNumber,
        storeNumber: this.userAction === 'profile' ? this.storeNumbers[0].storeNumber : (this.userAction === 'store-user-edit') ? (this.userView.stores.filter(s => s.storeNumber === this.selectedStoreNumber))[0].storeNumber : this.selectedItems,
        roleId: this.userAction === 'profile' ? this.storeNumbers[0].roleId : (this.userView.stores.filter(s => s.storeNumber === this.selectedStoreNumber))[0].roleId,
        language: this.userDataView.language,
        userStatus: this.userAction === 'profile' ? (this.storeNumbers[0].userStoreStatus === 'Y' ? true : false) : ((this.userView.stores.filter(s => s.storeNumber === this.selectedStoreNumber))[0].userStoreStatus === 'Y' ? true : false),
        esa: this.userAction === 'profile' ? this.storeNumbers[0].electronicSignatureAttestation : (this.userView.stores.filter(s => s.storeNumber === this.selectedStoreNumber))[0].electronicSignatureAttestation,
      });
      this.statusString = this.storeUserForm.controls.userStatus.value === true ? 'Active' : 'Inactive';
      this.markNameFieldsTouched();
    })
  }

  private trimmed(value: string): string {
    return typeof value === 'string' ? value.trim() : value;
  }

  private trimNameFields(): void {
    ['firstName', 'lastName', 'intials'].forEach(name => {
      const control = this.storeUserForm.controls[name];
      if (typeof control?.value === 'string') {
        const trimmed = control.value.trim();
        if (trimmed !== control.value) {
          control.setValue(trimmed);
        }
      }
    });
  }

  private markNameFieldsTouched(): void {
    ['firstName', 'lastName', 'intials'].forEach(name => {
      this.storeUserForm.controls[name].markAsTouched();
    });
  }

  getRoleByStore(selectevent: MatSelectChange) {
    this.storeUserForm.controls.roleId.setValue(this.getESA(selectevent.value).roleId);
  }

  getESAByStore(selectevent: MatSelectChange) {
    if (this.userAction !== 'store-user-add') {
      let store=this.getESA(selectevent.value);
      this.storeUserForm.controls.license.setValue(store.license);
      this.storeUserForm.controls.esa.setValue(store.electronicSignatureAttestation);
      this.storeUserForm.controls.roleId.setValue(store.roleId);
    }
   
  }

  getESA(storeNumber) {
    let store: StoreMaintainenceResponse[] = null
    if (this.userAction === 'profile') {
      store = this.user.stores.filter(e => e.storeNumber === storeNumber);
    } else {
      store = this.userView.stores.filter(e => e.storeNumber === storeNumber);
    }

    return store[0];


  }
  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  createForm() {
    this.storeUserForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      intials: [''],
      license: ['', Validators.required],
      upn: ['', Validators.required],
      storeNumber: [[], Validators.required],
      province: [''],
      roleId: ['', Validators.required],
      language: ['EN', Validators.required],
      userStatus: [true, Validators.required],
      esa: [{ value: '', disabled: true }],
      sequenceNumber: [0]


    });

  }

  setUserStatus(event: MatSlideToggleChange) {
    this.statusString = event.checked == true ? 'Active' : 'Inactive';
  }

  findStore() {
    this.storeUserForm.controls.storeNumber.setValue(this.storeNumbers.filter(s => s.storeNumber === this.selectedStoreNumber))
  }

  valid = false;
  isLoading = true;
  message = "";
  validateUser(user) {
    let valid = false;
    const loginRequest = {
      scopes: ["user.read"],
      loginHint: this.userData.upn

    }


    this.graphService.getUserProfile(user).then(user => {
      console.log(user);
      this.saveUserData();
      valid = true;
    },

      (error) => {
        console.log(error.code)
        // if(error.code==='Request_ResourceNotFound'){
        let dialogData = {
          title: this.userData.language === "EN" ? 'User Not Found' : "Utilisateur non trouvé",
          message: this.userData.language === "EN" ? "User not found in LCL Network." : "L'utilisateur n'a pas été trouvé dans le réseau LCL",

        }
        this.dialog.open(ApproveDialogComponent, {
          data: dialogData, panelClass: 'my-class'
        });
        // }
      })


  }


  saveProfile() {
    let nctmAccess=this.userData.nctmAccess;
    let userData = new UserData();
    userData.sequenceNumber = this.storeUserForm.controls.sequenceNumber.value;
    userData.license = this.storeUserForm.controls.license.value;
    userData.language = this.storeUserForm.controls.language.value;
    userData.firstName = this.storeUserForm.controls.firstName.value;
    userData.lastName = this.storeUserForm.controls.lastName.value;
    userData.storeNumber = [];
    userData.dcNumber = [];
    userData.storeNumber.push(this.storeUserForm.controls.storeNumber.value);

    this.userservice.saveProfile(userData).subscribe(data => {

      this.translate.use(userData.language.toLowerCase());
      let lang = userData.language.toLowerCase();
      if (lang === 'fr') {
        this.dateTimeFormat = "medium";
      } else {
        this.dateTimeFormat = "yyyy-MM-dd hh:mm:ss a";
      }

      this.userservice.getLoginUserData().subscribe(data => {
        this.translate.use(userData.language.toLowerCase());
        this.user = new UsersDataResponse()
        this.user = data;
        this.userData = data.userData
        this.userData.nctmAccess=nctmAccess;
        this.userservice.setCurrentUser(this.user);


        console.log(data);
        //this.backToSummary();
        let dialogData = {
          title: this.userData.language === "EN" ? 'Success' : "Succès",
          message: this.userData.language === "EN" ? 'Sucessfully Saved' : "Enregistré avec succès",
          buttonOk: true,
          buttonCancel: false,


        }
        this.dialog.open(DcnErrorComponent, {
          data: dialogData, panelClass: 'my-class'
        });
      })
    },
      (error: HttpErrorResponse) => {
        let dialogData = {
          title: 'Failed to Save',
          message: (error && error.error) ? error.error.message : "Failed to save user data."

        }
        this.dialog.open(DcnErrorComponent, {
          data: dialogData, panelClass: 'my-class'
        })
      })
  }

  saveUserData() {
    let userData = new UserData();
    //let token=this.userservice.getToken().subscribe(token=>{
    userData.sequenceNumber = 0;
    userData.storeNumber = [];
    if (this.userAction === 'profile' || this.userAction === 'store-user-edit') {
      userData.sequenceNumber = this.storeUserForm.controls.sequenceNumber.value;
      userData.storeNumber.push(this.storeUserForm.controls.storeNumber.value);
    } else {
      let stores = this.storeUserForm.controls.storeNumber.value.filter(s => (s !== 0));
      this.storeUserForm.controls.storeNumber.setValue(stores);
      stores.forEach(element => {
        userData.storeNumber.push(element);
      });

    }

    // userData.userId="ss3ee";
    userData.firstName = this.storeUserForm.controls.firstName.value;
    userData.lastName = this.storeUserForm.controls.lastName.value;
    userData.intials = this.storeUserForm.controls.intials.value;
    userData.license = this.storeUserForm.controls.license.value;
    userData.upn = this.storeUserForm.controls.upn.value;

    userData.dcNumber = [];

    userData.province = this.storeUserForm.controls.province.value;

    userData.roleId = (this.storeUserForm.controls.roleId.value);
    userData.language = this.storeUserForm.controls.language.value;
    userData.userStatus = this.storeUserForm.controls.userStatus.value ? 'Y' : 'N';

    this.userservice.saveUser(userData).subscribe(data => {
      console.log(data);
      this.backToSummary();
    }, (error: HttpErrorResponse) => {
      console.log(error);
      let dialogData = {
        title: this.userData.language === 'EN' ? 'Failed to Save' : 'L’enregistrement a èchoué',
          message: (error && error.error && error.status===409)
         ? (this.userData.language === 'EN' ? error.error.message : "Ce nom d’utilisateur existe déjà. Les comptes d'utilisateurs en double ne peuvent pas être créés") 
         :(this.userData.language === 'EN'?"Failed to save user data.":'L’enregistrement a èchoué')
      }
      this.dialog.open(ApproveDialogComponent, {
        data: dialogData, panelClass: 'my-class'
      });
    })

    //})
  }

  backToSummary() {
    if (this.userAction === 'store-user-edit') {
      this.router.navigate(['/dcn-esign/store-management/store-users', this.selectedStoreNumber]);
    } else
      if (this.userAction === 'store-user-add') {
        this.router.navigate(['/dcn-esign/store-management/store-users', this.storeUserForm.controls.storeNumber.value.length > 0 ? this.storeUserForm.controls.storeNumber.value[0] : '']);
      } else {
        //    this.router.navigate(['/dcn-esign/store-management/store-users']);
      }
  }

 

  exitProfile() {
    this.router.navigate(['/dcn-esign/']);
  }
  @ViewChild('mySel') skillSel: MatSelect;
  allSelected = false;
  toggleAllSelection() {
   
      
    
        this.skillSel.options.forEach( (item : MatOption) => item.select());
      
    //  this.skillSel.close();
  }

  toggleAllDeSelection() {
    this.selectedStores=[]
        this.skillSel.options.forEach( (item : MatOption) => {item.deselect()});
        
    //  this.skillSel.close();
  }

  onKey(value) {
    this.stores = this.search(value);
   // this.filterBanksMulti(value);
  }

  search(value: string) {
    value = value.toLowerCase();
    return  this.storeNumbers.filter(option => (option.banner + "-" + option.sdmStoreNumber).toLowerCase().includes(value));
    
  }
 

  onChange(event){
    let stores=event.value;

    stores.forEach(element => {
      let index=this.selectedStores.indexOf(element);
      if(index>-1){
      this.selectedStores.splice(element,1)
      }else{
      this.selectedStores.push(element);
      }
    });
    

  }
  
  private _filter(value: string): StoreMaintainenceResponse[] {
    const filterValue = value.toLowerCase();
    // Set selected values to retain the selected checkbox state 
    this.setSelectedValues();
    this.storeUserForm.controls.storeNumber.patchValue(this.selectedStores);
    let filteredList = this.storeNumbers.filter(option => (option.banner + "-" + option.sdmStoreNumber).toLowerCase().includes(filterValue));
    return filteredList;
  }
  



  setSelectedValues() {
    let value=this.storeUserForm.controls.storeNumber.value;
    console.log('selectFormControl', value);
    if (value && value.length > 0) {
      value.forEach((e) => {
        if (this.selectedStores.indexOf(e) == -1) {
          this.selectedStores.push(e);
        }
      });
    }
  }
  selectionChange(event) {
    if (event.isUserInput && event.source.selected == false) {
      let index = this.selectedStores.indexOf(event.source.value);
      this.selectedStores.splice(index, 1)
    }
  }

  clearSearch(event) {
    event.stopPropagation();
    this.searchTextboxControl.patchValue('');
  }

}
